<template>
  <div>
    <el-dialog :title="$t('system.add_user')" class="diglog-card" :close-on-click-modal="false" :visible.sync="dialogUserVisible" width="500px" @close="initData">
      <div class="section-title">
        {{ $t('system.account_details') }}
      </div>
      <div class="section-tip">
        {{ $t('tips.enter_account_details_new_user') }}
      </div>
      <el-form ref="form" :model="form" label-width="150px" :rules="rules" label-position="left" class="form-contaniner">
        <el-form-item :label="$t('system.username')" prop="username" required>
          <el-input v-model="form.username" size="small" placeholder="Enter username" class="search-frame" autocomplete="off" clearable />
        </el-form-item>
        <el-form-item :label="$t('system.login_email')" prop="email" required>
          <el-input v-model="form.email" size="small" placeholder="Enter login email" class="search-frame" autocomplete="off" clearable />
        </el-form-item>
        <el-form-item :label="$t('system.password')" prop="password" required>
          <el-input
            v-model="form.password"
            type="password"
            size="small"
            placeholder="Enter password"
            class="search-frame"
            autocomplete="off"
            clearable
            show-password
            :readonly="flag"
            @focus="getFocus"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="dialogUserVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="info" :disabled="listLoading" @click="submitAddUser('form')">{{ $t('components.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addMerchantUser } from '@/api/system/system'
import { cryptoJSAesEncrypt } from '@/utils/encrypt'

export default {
  name: 'AddUserModal',
  data() {
    const checkPasswordLength = (rule, value, callback) => {
      if (!value || value.length < 8 || value.length > 15) {
        return callback(new Error('password must between 8 ~ 15 character'))
      }
      const regex = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@%*&_])[A-Za-z\\d@%*&_]{8,15}$')
      if (!regex.test(value)) {
        return callback(new Error('Passwords must be between 8 and 15 characters. Must contain and only contain the following: uppercase and lowercase letters, alphabets, and special characters (limited to @%*&_).'))
      }

      return callback()
    }
    return {
      dialogUserVisible: false,
      listLoading: false,
      form: {
        username: '',
        password: '',
        email: ''
      },
      flag: true,
      rules: {
        password: [
          { validator: checkPasswordLength, trigger: ['blur', 'change'] }
        ],
        email: [
          { type: 'email', message: 'Please input the correct email', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  mounted() {
    this.$bus.off('SHOW_ADD_USER_MODAL')
    this.$bus.on('SHOW_ADD_USER_MODAL', (value) => {
      this.dialogUserVisible = value[0]
    })
  },
  methods: {
    initData() {
      this.form = {}
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    getFocus() {
      this.flag = false
    },
    submitAddUser(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.listLoading = true
          const params = {
            username: cryptoJSAesEncrypt(this.form.username),
            password: cryptoJSAesEncrypt(this.form.password),
            email: cryptoJSAesEncrypt(this.form.email)
          }
          addMerchantUser(params).then(res => {
            this.$message.success('Success')
            this.$bus.emit('RE_GER_MERCHANT_USER')
            this.dialogUserVisible = false
          }).finally(() => {
            this.listLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.form-contaniner{
  margin: 20px 0 0;
}
</style>
